<template>
    <div class="history-entrust-root">
        <Top></Top>
        <EntrTab></EntrTab>
        <div class="history-entrust-body___1UbSf">
            <div class="main___3Uo2D">
<!--                 <div class="menu___3N_wL">
                    <div class="menu___aQSZq">
                        <ul class="ant-menu kc-menu  ant-menu-light ant-menu-root ant-menu-inline">
                            <li class="ant-menu-item" :class="active == 'now-person' ? 'ant-menu-item-selected' : ''"
                                style="padding-left: 16px;" @click="changeTab('/invite/person','now-person')">
                                <a>{{ $t('m.component.top.invite[0]') }}</a>
                            </li>
                            <li class="ant-menu-item"
                                :class="active == 'now-reward' ? 'ant-menu-item-selected' : ''"
                                style="padding-left: 16px;" @click="changeTab('/invite/reward','now-reward')">
                                <a>{{ $t('m.component.top.invite[1]') }}</a>
                            </li>
                        </ul>
                    </div>
                </div> -->
                <div class="right___2ELAC">
                    <div class="ant-card ant-card-bordered ant-card-wider-padding ant-card-padding-transition"
                         style="min-height: 550px;">
                        <div class="ant-card-head">
                            <div class="ant-card-head-wrapper">
                                <div class="ant-card-head-title">{{ $t('m.component.top.invite[1]') }}</div>
                            </div>
                        </div>
                        <div class="ant-card-body">
                            <div class="filter___2AY3J">
                                <div class="ant-row-flex ant-row-flex-middle filterRow___2tIhR">
                                    <div class="label___1yE6x">{{ $t('m.order.time[3]') }}</div>
                                    <div class="kcRangePicker___3QFSs">
                                        <span class="ant-calendar-picker ant-calendar-picker-small">
                                            <el-date-picker
                                                v-model="timeRange"
                                                type="daterange"
                                                @blur="timeSearch()"
                                                unlink-panels
                                                :range-separator="$t('m.order.text[1]')"
                                                :start-placeholder="$t('m.order.text[0]')"
                                                :end-placeholder="$t('m.order.text[2]')">
                                            </el-date-picker>
                                        </span>
                                        <div class="miniDivider___Wh7bp ant-divider ant-divider-vertical"></div>
                                        <div class="ant-radio-group ant-radio-group-solid filter-radio-button kc-radio-group">

                                            <label class="kc-radio-btn ant-radio-button-wrapper"
                                                   :class="timeActive == 'month' ? 'ant-radio-button-wrapper-checked' : ''"
                                                   @click="timeSearch2('month')">
                                                <span>{{ $t('m.order.time[2]') }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="ant-row-flex ant-row-flex-middle filterRow___2tIhR">
                                    <div class="label___1yE6x">{{ $t('m.component.deal.bottom.title[1]') }}</div>
                                    <div class="ant-radio-group ant-radio-group-solid filter-radio-button kc-radio-group">
                                        <label class=" kc-radio-btn ant-radio-button-wrapper"
                                               :class="directionActive == 'all' ? 'ant-radio-button-wrapper-checked' : ''"
                                               @click="typeSelect('all', '')">
                                            <span style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{ $t('m.order.side[0]') }}</span>
                                        </label>
                                        <label class=" kc-radio-btn ant-radio-button-wrapper"
                                               :class="directionActive == 'sell' ? 'ant-radio-button-wrapper-checked' : ''"
                                               @click="typeSelect('sell', 1)">
                                            <span style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{ $t('m.order.side[1]') }}</span>
                                        </label>
                                        <label class=" kc-radio-btn ant-radio-button-wrapper"
                                               :class="directionActive == 'buy' ? 'ant-radio-button-wrapper-checked' : ''"
                                               @click="typeSelect('buy', 2)">
                                            <span style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{ $t('m.order.side[2]') }}</span>
                                        </label>
                                    </div>
                                </div>
                                 <div class="ant-row-flex ant-row-flex-middle filterRow___2tIhR">
                                     <div class="label___1yE6x">{{ $t('m.component.deal.bottom.title[17]') }}</div>
                                     <div class="ant-radio-group ant-radio-group-solid filter-radio-button kc-radio-group">
                                        <label class=" kc-radio-btn ant-radio-button-wrapper"
                                               :class="curActive == 'all' ? 'ant-radio-button-wrapper-checked' : ''"
                                               @click="curSelect('all')">
                                            <span style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{ $t('m.order.type[0]') }}</span>
                                        </label>
                                        <label class=" kc-radio-btn ant-radio-button-wrapper"
                                                :class="curActive == item.id ? 'ant-radio-button-wrapper-checked' : ''"
                                                @click="curSelect(item.id)" v-for="(item,index) in currencyBase">
                                             <span style="position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{item.currency_name}}</span>
                                        </label>
                                     </div>
                                 </div>

                            </div>
                            <div class="ant-table-wrapper table___3RU8w ">
                                <div class="ant-spin-nested-loading">
                                    <div class="ant-spin-container">
                                        <div class="ant-table ant-table-default ant-table-empty ant-table-scroll-position-left">
                                            <div class="ant-table-body">
                                                <table>
                                                    <thead class="ant-table-thead">
                                                    <tr>
                                                        <th><span>{{ $t('m.component.deal.person[0]') }}</span></th>
                                                        <th><span>{{ $t('m.component.deal.person[1]') }}</span></th>
                                                        <th><span>{{ $t('m.component.deal.person[2]') }}</span></th>
                                                        <th><span>{{ $t('m.component.deal.person[3]') }}</span></th>
                                                        <th><span>{{ $t('m.component.deal.person[4]') }}</span></th>
                                                        <th><span>{{ $t('m.component.deal.person[5]') }}</span></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody class="ant-table-tbody">
                                                        <tr v-for="(item,k) in entrustList" :key="k">
                                                            <td>
                                                                <span>{{ idToName(item.cid)}} / {{ idToName(item.bcid)}}</span>
                                                            </td>
                                                            <td>
                                                                <span v-if="item.ua_type==1">{{$t('m.component.deal.person[6]') }}</span>
                                                                <span v-else>{{$t('m.component.deal.person[7]')}}</span>
                                                            </td>
                                                            <td>
                                                                <span>{{ item.fee_to | roundOff(6)}}</span>
                                                            </td>
                                                            <td>
                                                                <span>{{ item.fee_all | roundOff(6)}}</span>
                                                            </td>
                                                            <td>
                                                                <span>{{ item.email}}</span>
                                                            </td>
                                                            <td>
                                                                <span>{{ item.ct_time }}</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="ant-table-placeholder">
                                                <div style="cursor: pointer" @click="loadMore()"
                                                     v-if="entrustList.length != 0 && !isEnd">{{ $t('m.order.text[3]') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <loadV></loadV>
                                <div v-if="!!!entrustList.length&&!loadV.show" style="text-align: center;">{{$t('m.component.deal.tips[0]')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Bottom></Bottom>
        <myAlert></myAlert>
    </div>
</template>

<script>
    import Top from '@/components/top';
    import Bottom from '@/components/bottom';
    import axios from "axios";
    import EntrTab from "@/components/entrTab";

    export default {
        name: "invite_reward",
        mounted() {
            this.request.uid = this.userInfo.uid;
            this.getEntrust();
        },
        components: {
            Top, Bottom, EntrTab
        },
        data() {
            return {
                active: 'now-reward',
                directionActive: 'all',
                typeActive: 'all',
                dealShow: false,
                entrustList: [],
                timeActive: 'month',
                timeRange: [], // 时间范围选择
                request: {
                    // order_in: 1,
                    page: 1,
                    pageSize: 10,
                    // type: '',
                    tradeType: '',
                    timeBegin: 0,
                    timeEnd: '',
                    bcid:'',
                },
                isEnd:false,
                curActive:'all',//基础币选中项
            }
        },
        filters: {
        },
        methods: {
            changeTab: function (url, path) {
                this.active = path;
                this.changeRoute(url);
            },
            getEntrust: function () {
                if (this.isEnd) return;
                this.request.timeEnd = this.request.timeEnd?this.request.timeEnd:parseInt(new Date().getTime()/1000);
                this.aLoadV({show: true});
                let paramData = this.signRequest(this.request);
                paramData.signature = this.signature(paramData);
                this.$axios.get(this.requestConfig.host + "/index/User/userFee", {
                    params: paramData
                }).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.aLoadV({show: false});
                    this.entrustList = this.entrustList.concat(res.data);
                    if (res.data.length < this.request.pageSize) this.isEnd = true;
                }).catch((e) => {
                    if (e == 20001) return;
                    this.aLoadV({show: false});
                    this.aMyAlert({msg: this.$t('m.common.order.text[0]'), show: true});
                });
            },
            loadMore: function () {
                this.request.page++;
                this.getEntrust();
            },
            typeSelect: function (direction, tradeType) {
                this.entrustList = [];
                this.directionActive = direction;
                this.request.tradeType = tradeType;
                this.request.page = 1;
                this.isEnd = false;
                this.getEntrust();
            },
            // tradetypeSelect: function (type, tradetype) {
            //     this.entrustList = [];
            //     this.typeActive = type;
            //     this.request.pageNo = 1;
            //     this.request.tradetype = tradetype;
            //     this.isEnd = false;
            //     this.getEntrust();
            // },
            timeSearch() {
                if (this.timeRange.length == 0) return;
                this.request.timeBegin = new Date(this.timeRange[0]).getTime() / 1000;
                this.request.timeEnd = new Date(this.timeRange[1]).getTime() / 1000 + 24 * 60 * 60 -1;
                this.entrustList = [];
                this.isEnd = false;
                this.getEntrust();
            },
            timeSearch2(v) {
                this.timeRange = [];
                this.timeActive = v;
                switch (v) {
                    case "day":
                        this.request.timeBegin = new Date(new Date().toLocaleDateString()).getTime() / 1000;
                        break;
                    case "month":
                        this.request.timeBegin = new Date(new Date().toLocaleDateString()).getTime() / 1000 - 30 * 24 * 60 * 60;
                        break;
                }
                this.entrustList = [];
                this.isEnd = false;
                this.getEntrust();
            },
            curSelect(id){
                //基础币筛选
                this.curActive = id;
                if (id=='all') {
                    id = '';
                }
                this.isEnd = false;
                this.request.bcid = id;
                this.getEntrust();
            },
        }
    }
</script>

<style scoped>
    @import "../../assets/css/history-entrust.css";
</style>
